import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'

interface IArrowScrollButtonWrapperProps {
  $direction: 'left' | 'right'
  $isVisible: boolean
}

export const ArrowScrollButtonWrapper = styled.button<IArrowScrollButtonWrapperProps>`
  position: absolute;
  top: 50%;
  ${({ $direction }) => $direction}: -1px;
  transform: translateY(-50%);
  width: 20px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: ${({ $direction }) =>
    $direction === 'left' ? 'start' : 'end'};
  background: linear-gradient(
    ${({ $direction }) => ($direction === 'left' ? '90deg' : '-90deg')},
    ${COLORS.white} 19.62%,
    rgba(234, 242, 255, 0) 154.17%
  );
  ${({ $isVisible }) =>
    $isVisible
      ? css`
          opacity: 1;
          pointer-events: auto;
        `
      : css`
          opacity: 0;
          pointer-events: none;
        `}

  cursor: pointer;
  z-index: 1;
  transition: all 0.2s ease;

  &:hover {
    background: ${COLORS.primaryLight};
  }

  ${({ $direction }) =>
    $direction === 'right' &&
    css`
      & > svg {
        transform: rotate(180deg);
      }
    `}
`
